var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoAgro(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 32.813,
    viewBox: "0 0 40 32.813",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_43345",
    "data-name": "Caminho 43345",
    d: "M9.375,180a9.375,9.375,0,1,0,9.375,9.375A9.386,9.386,0,0,0,9.375,180Zm0,16.406a7.031,7.031,0,1,1,7.031-7.031A7.039,7.039,0,0,1,9.375,196.406Zm0,0",
    transform: "translate(0 -165.938)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_43346",
    "data-name": "Caminho 43346",
    d: "M78.516,255a3.516,3.516,0,1,0,3.516,3.516A3.52,3.52,0,0,0,78.516,255Zm0,4.688a1.172,1.172,0,1,1,1.172-1.172A1.173,1.173,0,0,1,78.516,259.688Zm0,0",
    transform: "translate(-69.141 -235.078)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_43347",
    "data-name": "Caminho 43347",
    d: "M42.68,20.545V16.406a4.693,4.693,0,0,0-4.687-4.687H35.649V5.859A1.173,1.173,0,0,1,36.82,4.687V2.343A3.52,3.52,0,0,0,33.3,5.859v5.859H28.161L25.349,2.343h1.941V0H8.539V2.343h2.344v7.48a14.066,14.066,0,0,0-5.434,2.766L6.942,14.4a11.719,11.719,0,0,1,19.176,9.041v3.516h4.942a7.031,7.031,0,1,0,11.62-6.408ZM13.227,9.424V2.343H22.9l2.813,9.375H22.163A13.98,13.98,0,0,0,14.4,9.374q-.588,0-1.172.05ZM24.87,14.062H37.992a2.346,2.346,0,0,1,2.344,2.344v2.746a7,7,0,0,0-2.344-.4H27.657a14.075,14.075,0,0,0-2.786-4.687Zm3.394,7.031h4.492a7.01,7.01,0,0,0-1.7,3.516h-2.6V23.437a14.065,14.065,0,0,0-.2-2.344Zm9.728,9.375a4.688,4.688,0,1,1,4.688-4.687A4.693,4.693,0,0,1,37.992,30.468Zm0,0",
    transform: "translate(-5.023 0)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_43348",
    "data-name": "Caminho 43348",
    d: "M409.344,316.172A1.172,1.172,0,1,1,408.172,315,1.172,1.172,0,0,1,409.344,316.172Zm0,0",
    transform: "translate(-375.203 -290.391)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAgro);
export default __webpack_public_path__ + "static/media/ico-agro.e80fd2071d0ad893488c22582b1c6fad.svg";
export { ForwardRef as ReactComponent };